
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Navigation from './components/feature/Navigation';
import Footer from './components/feature/Footer';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { useVisitorTracking } from './hooks/useVisitorTracking';

function App() {
  useVisitorTracking();

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ProtectedRoute>
        <div className="min-h-screen flex flex-col">
          <Navigation />
          <main className="flex-1">
            <AppRoutes />
          </main>
          <Footer />
        </div>
      </ProtectedRoute>
    </BrowserRouter>
  );
}

export default App;
